<template>
  <v-app>
    <AppBar />
    <v-main style="background-color:#F4F7FF; min-height:100vh;">
      <router-view />
    </v-main>
    <FooterBar />
  </v-app>
</template>

<script>
import AppBar   from './components/AppBar.vue'
import FooterBar from './components/Footer.vue'

export default {
  name: 'App',
  components: { AppBar, FooterBar },
  created () {
    this.$store.dispatch('fetchMenus')
  },
}
</script>
